import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './zoid/button'
import MyButtonComponent from './ButtonComponent'
console.log(window.xprops)
ReactDOM.render(
    <MyButtonComponent { ...window.xprops }/>,
    document.querySelector('#root')
);



// WEBPACK FOOTER //
// ./src/button.js